import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movieData';

export default function CategoryTabs() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            探索影视分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            最新电视剧更新、最新电影上映、最新综艺在线——影视更新快，新剧抢先看
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-50 border border-transparent hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed hidden md:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}